// GENERATED FILE - DO NOT MODIFY

export enum UpdateClubInvitationsActionDto {
    Add = "Add",
    Remove = "Remove",
}